const en = {
  translation: {
    nav: {
      home: "Home",
      about: "About Us",
      actions: "Social Actions",
      stats: "Impact",
      contact: "Contact",
      donate: "Support",
    },
    hero: {
      badge: "Angola, Africa",
      headline1: "We Transform",
      headline2: "Lives.",
      headline3: "We Build",
      headline4: "Futures.",
      subheadline: "The Ngana Zenza Foundation works at the heart of Angola, bringing hope, education and dignity to communities that need it most.",
      cta_primary: "Learn About Us",
      cta_secondary: "How to Support",
      stat_people: "People Impacted",
      stat_provinces: "Provinces",
      stat_projects: "Projects",
      stat_years: "Years of Impact",
    },
    about: {
      title: "About Us",
      subtitle: "A foundation born from the conviction that every Angolan deserves an opportunity to thrive.",
      history_title: "Our History",
      history_text1: "The Ngana Zenza Foundation was established in 2010 by a group of community leaders and Angolan professionals committed to the social transformation of the country. The name 'Ngana Zenza' is a tribute to Angola's cultural roots, evoking the ancestral wisdom of its people and the strength of communities.",
      history_text2: "Since its founding, the organisation has grown steadily, expanding its presence across multiple Angolan provinces and building bridges between communities, the State and international partners.",
      mission_title: "Mission",
      mission_text: "To promote sustainable human development in Angola, through integrated programmes of education, health, professional training and social protection, with respect for the cultural identity and dignity of each person.",
      vision_title: "Vision",
      vision_text: "An Angola where every child has access to education, every family lives with dignity, and every community has the capacity to build its own future.",
      values_title: "Values",
      value_dignity: "Dignity",
      value_dignity_desc: "We respect the humanity and culture of every person we serve.",
      value_transparency: "Transparency",
      value_transparency_desc: "We manage resources responsibly and are accountable to all our partners.",
      value_impact: "Impact",
      value_impact_desc: "We guide every decision by the concrete results in people's lives.",
      value_community: "Community",
      value_community_desc: "We believe the most lasting solutions are born within the communities themselves.",
      value_innovation: "Innovation",
      value_innovation_desc: "We constantly seek new approaches to old challenges.",
      team_title: "Our Leadership Team",
      founder_title: "Founder and President",
      founder_name: "Dr. Manuel António Zenza",
      founder_bio: "With over 20 years of experience in social development and international cooperation, Dr. Manuel António Zenza founded the organisation after witnessing deep inequalities in rural Angolan communities. He holds a degree in Social Sciences from Agostinho Neto University and a Master's in International Development from the University of Porto.",
      timeline_title: "A Decade of Transformation",
    },
    stats: {
      title: "Our Impact in Numbers",
      subtitle: "Each number represents a life transformed, a family supported, a future built.",
      people: "People Impacted",
      children: "Children Supported",
      families: "Families Helped",
      provinces: "Provinces Reached",
      projects: "Projects Completed",
      volunteers: "Active Volunteers",
      partners: "Strategic Partners",
      schools: "Schools Built",
    },
    actions: {
      title: "Our Actions",
      subtitle: "Each project stems from a real need identified in the communities where we work.",
      all: "All",
      education: "Education",
      health: "Health",
      community: "Community",
      emergency: "Emergency",
      action1_title: "School of the Future",
      action1_desc: "Construction and rehabilitation of school infrastructure in rural areas, ensuring dignified learning conditions for over 3,000 children in Huambo and Bié provinces.",
      action2_title: "Health for All",
      action2_desc: "Medical screening and follow-up programme in communities without access to healthcare. Over 15,000 consultations carried out in partnership with the Ministry of Health.",
      action3_title: "Women Who Transform",
      action3_desc: "Professional training and microcredit for women entrepreneurs in Luanda and Malanje. Over 800 micro-enterprises created, generating employment and family income.",
      action4_title: "Clean Water, Healthy Life",
      action4_desc: "Installation of potable water supply systems in remote inland villages. Over 40 boreholes drilled, benefiting 25,000 people.",
      action5_title: "Protected Childhood",
      action5_desc: "Support programme for vulnerable children, including scholarships, school materials and psychosocial support. 2,200 children currently under care.",
      action6_title: "Resilient Villages",
      action6_desc: "Integrated community development programme that strengthens villages' self-management capacity, including local leader training and sustainable agriculture support.",
    },
    contact: {
      title: "Contact Us",
      subtitle: "We are here to answer your questions, receive suggestions and establish partnerships.",
      form_name: "Full Name",
      form_email: "Email Address",
      form_subject: "Subject",
      form_message: "Message",
      form_submit: "Send Message",
      form_success: "Message sent successfully. We will be in touch shortly.",
      address_title: "Headquarters",
      address: "Rua Comandante Gika, No. 47, Maianga, Luanda, Angola",
      phone_title: "Phone",
      email_title: "Email",
      hours_title: "Hours",
      hours: "Monday to Friday, 8am to 5pm",
      volunteer_title: "Become a Volunteer",
      volunteer_desc: "Join our network of volunteers and help transform lives in Angola.",
      volunteer_cta: "Apply Now",
      partner_title: "Become a Partner",
      partner_desc: "Your organisation can be part of this mission. Contact us to find out how.",
      partner_cta: "Learn More",
      social_title: "Social Media",
    },
    footer: {
      tagline: "Transforming lives. Building futures.",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      transparency: "Transparency Report",
      registered: "Organisation registered with the Ministry of Territorial Administration of Angola.",
    },
    donate: {
      title: "Your Support Makes a Difference",
      subtitle: "With your contribution, we can reach further and impact more lives.",
      cta: "Make a Donation",
    },
  }
};

export default en;
